import { findStoreOfTypeInTree } from '../../_mobxStateTree/MobxStateTreeHelpers';
import { debugError } from '../../../logging/DebugLogger';
import { isArray } from '../../../helpers/ArrayHelpers';
var SnapshotToStoreMapper = /** @class */ (function () {
    function SnapshotToStoreMapper(rootStore) {
        this.rootStore = rootStore;
        this.storeOfType = new Map();
    }
    SnapshotToStoreMapper.prototype.getStoreOfType = function (modelType) {
        var store = this.storeOfType.get(modelType);
        if (!store) {
            store = findStoreOfTypeInTree(this.rootStore, modelType);
            if (!store) {
                debugError('Error in SnapshotToStoreMapper.getStoreOfType: No store found in rootStore for the given type', {
                    rootStore: this.rootStore,
                    modelType: modelType
                });
                return undefined;
            }
            this.storeOfType.set(modelType, store);
        }
        return store;
    };
    SnapshotToStoreMapper.prototype.map = function (snapshot, modelType) {
        // get target store
        var store = this.getStoreOfType(modelType);
        // if no store found => nothing to do
        if (!store) {
            return;
        }
        // addOrApplySnapshot in store
        if (isArray(snapshot)) {
            store.addOrApplySnapshot(snapshot);
        }
        else {
            store.addOrApplySnapshot(snapshot);
        }
    };
    return SnapshotToStoreMapper;
}());
export default SnapshotToStoreMapper;
//# sourceMappingURL=SnapshotToStoreMapper.js.map